import React, { useEffect } from 'react';

const CustomCursor = () => {
  useEffect(() => {
    document.body.style.cursor = 'none';  // ✅ Default cursor hide

    const cursor = document.createElement('div');
    cursor.classList.add('custom-cursor');
    document.body.appendChild(cursor);

    const moveCursor = (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    };

    document.addEventListener('mousemove', moveCursor);

    return () => {
      document.removeEventListener('mousemove', moveCursor);
      document.body.style.cursor = 'auto'; // Reset on unmount
      document.body.removeChild(cursor);
    };
  }, []);

  return null;
};

export default CustomCursor;
